 

function ItemBox(probs) {

    return ( 
       <>
          <div className="timeline-item">
                    <div className="timeline-icon" />
                    <div className="timeline-content">
                        <h3 className="timeline-title">{probs.title}</h3>
                        <span className="timeline-date">{probs.date}</span>
                        <p>{probs.detail}</p>
                    </div>
          </div>
       </> 
 ); 

}

export default ItemBox;